import { Entity } from '../core/entity.js';
import { drawPlayer } from '../render/player_art.js';
import { PALETTE } from '../render/sketch.js';

/**
 * 访客（别的玩家）：沿用玩家的骨骼画法，靠头顶名牌区分。
 * 位置由 coop 系统插值追赶网络目标点，不跑碰撞。
 */
export function createVisitor({ id, name = '客', color = PALETTE.clothBlue, x = 0, y = 0, facing = 'down' } = {}) {
  const e = new Entity({
    name,
    transform: { x, y, w: 14, h: 10 },
    anim: { facing, moving: false, phase: 0 },
    visitor: {
      id,
      color,
      tx: x, ty: y,          // 网络目标点
      facing,
      moving: false,
      lastSeen: 0,           // 由 coop 系统填写
      riding: false,         // 正开着车：由 coop 系统按对方报上来的 ride 填
      bubble: '',
      bubbleUntil: 0,
    },
  }, ['visitor']);

  e.drawable = {
    draw(ctx, self, view) {
      const v = self.visitor;
      ctx.save();
      // 坐在车里：车由 coop 画的那辆影子车负责，这儿只留头顶的名牌
      if (!v.riding) {
        drawPlayer(ctx, self.transform.x, self.transform.y, {
          facing: self.anim.facing,
          moving: self.anim.moving,
          phase: self.anim.phase,
          time: view.time,
        });
      }

      // 头顶名牌：一个色点 + 称呼
      const cx = self.transform.x;
      const ny = self.transform.y - 38;
      ctx.font = '12px "LXGW WenKai Lite","Kaiti SC","STKaiti","KaiTi",serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      const w = Math.max(26, ctx.measureText(self.name).width + 16);
      ctx.fillStyle = 'rgba(255,252,244,0.88)';
      ctx.strokeStyle = PALETTE.inkSoft;
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.roundRect(cx - w / 2, ny - 8, w, 16, 7);
      ctx.fill();
      ctx.stroke();
      ctx.fillStyle = v.color;
      ctx.beginPath();
      ctx.arc(cx - w / 2 + 8, ny, 3, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = PALETTE.ink;
      ctx.fillText(self.name, cx + 4, ny + 1);

      // 说话气泡
      if (v.bubble && view.time < v.bubbleUntil) {
        const by = ny - 20;
        ctx.font = '13px "LXGW WenKai Lite","Kaiti SC","STKaiti","KaiTi",serif';
        const bw = Math.min(200, ctx.measureText(v.bubble).width + 18);
        ctx.fillStyle = 'rgba(255,252,244,0.95)';
        ctx.strokeStyle = PALETTE.ink;
        ctx.lineWidth = 1.2;
        ctx.beginPath();
        ctx.roundRect(cx - bw / 2, by - 11, bw, 22, 8);
        ctx.fill();
        ctx.stroke();
        ctx.fillStyle = PALETTE.ink;
        ctx.fillText(v.bubble, cx, by);
      }
      ctx.restore();
    },
  };

  return e;
}
